/* @flow */

import * as React from 'react';
import isNumeric from 'isnumeric';
import MatchScoreLine from './MatchScoreLine';

type Props = {
  awayTeam?: string,
  awayScore?: string,
  gameName?: string,
  homeTeam?: string,
  homeScore?: string,
  isNumberScore?: boolean,
  reverseOrder?: boolean
};

const defaultProps = {
  awayTeam: '',
  awayScore: undefined,
  gameName: '',
  homeTeam: '',
  homeScore: undefined,
  isNumberScore: false,
  reverseOrder: false
};

function isHigherNumber(a, b) {
  return isNumeric(a) && isNumeric(b) && parseInt(a, 10) > parseInt(b, 10);
}

function MatchScore({
  awayTeam = defaultProps.awayTeam,
  awayScore,
  gameName = defaultProps.gameName,
  homeTeam = defaultProps.homeTeam,
  homeScore,
  isNumberScore,
  reverseOrder
}: Props) {
  if (!awayTeam && !homeTeam && gameName) {
    return <div>{gameName}</div>;
  }

  const isDraw = homeScore === awayScore;
  const homeLead = isHigherNumber(homeScore, awayScore);
  const awayLead = isHigherNumber(awayScore, homeScore);

  if (reverseOrder) {
    return (
      <div>
        <MatchScoreLine
          team={awayTeam}
          score={awayScore}
          isDraw={isDraw}
          isHighScore={awayLead}
          isNumberScore={isNumberScore}
        />
        <MatchScoreLine
          team={homeTeam}
          score={homeScore}
          isDraw={isDraw}
          isHighScore={homeLead}
          isNumberScore={isNumberScore}
          isHomeTeam
        />
      </div>
    );
  }

  return (
    <div>
      <MatchScoreLine
        team={homeTeam}
        score={homeScore}
        isDraw={isDraw}
        isHighScore={homeLead}
        isNumberScore={isNumberScore}
        isHomeTeam
      />
      <MatchScoreLine
        team={awayTeam}
        score={awayScore}
        isDraw={isDraw}
        isHighScore={awayLead}
        isNumberScore={isNumberScore}
      />
    </div>
  );
}

MatchScore.defaultProps = defaultProps;

export default MatchScore;
